/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  BuybackDetailsSyncResult,
  BuybackInsuranceTerms,
  BuybackPledges,
  BuybackSyncLastRead,
  BuybackSyncResult,
  Hangar,
  HangarBuybacksParams,
  HangarEquipmentParams,
  HangarExportParams,
  HangarFlairParams,
  HangarItemsList,
  HangarLinkExportParams,
  HangarPaintsParams,
  HangarParams,
  HangarPledgeItems,
  HangarShipComponentsParams,
  HangarSyncLastRead,
  HangarSyncStatus,
  HangarSyncSubmitResult,
  HangarUpgradesParams,
  ImportInput,
  ImportSubmitResult,
  RsiPageReportInput,
  SchemaValidationErrorResponse,
  StandardError,
  SyncRsiBuybackDetailsInput,
  SyncRsiBuybacksInput,
  SyncRsiHangarInput,
  ValidationError,
  VehicleExportsList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Clear your personal Hangar
 */
export const destroyHangar = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/hangar`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarMutationKey = () => ['destroyHangar'] as const;

export const getDestroyHangarMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangar>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangar>>, TError,void, TContext> => {

const mutationKey = getDestroyHangarMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangar>>, void> = () => {


          return  destroyHangar()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangar>>>

    export type DestroyHangarMutationError = ErrorType<StandardError>


    /**
 * @summary Clear your personal Hangar
 */
export const useDestroyHangar = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangar>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangar>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyHangarMutationOptions(options), queryClient);
    }
    /**
 * @summary Your personal Hangar
 */
export const hangar = (
    params?: MaybeRefOrGetter<HangarParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Hangar>(
      {url: `/hangar`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarQueryKey = (params?: MaybeRefOrGetter<HangarParams>,) => {
    return [
    'hangar', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarQueryOptions = <TData = Awaited<ReturnType<typeof hangar>>, TError = ErrorType<StandardError>>(params?: MaybeRefOrGetter<HangarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangar>>> = ({ signal }) => hangar(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangar>>, TError, TData>
}

export type HangarQueryResult = NonNullable<Awaited<ReturnType<typeof hangar>>>
export type HangarQueryError = ErrorType<StandardError>


/**
 * @summary Your personal Hangar
 */

export function useHangar<TData = Awaited<ReturnType<typeof hangar>>, TError = ErrorType<StandardError>>(
 params?: MaybeRefOrGetter<HangarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Buy-back Pledges
 */
export const hangarBuybacks = (
    params?: MaybeRefOrGetter<HangarBuybacksParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<BuybackPledges>(
      {url: `/hangar/buybacks`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarBuybacksQueryKey = (params?: MaybeRefOrGetter<HangarBuybacksParams>,) => {
    return [
    'hangar','buybacks', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarBuybacksQueryOptions = <TData = Awaited<ReturnType<typeof hangarBuybacks>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarBuybacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarBuybacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarBuybacksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarBuybacks>>> = ({ signal }) => hangarBuybacks(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarBuybacks>>, TError, TData>
}

export type HangarBuybacksQueryResult = NonNullable<Awaited<ReturnType<typeof hangarBuybacks>>>
export type HangarBuybacksQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Buy-back Pledges
 */

export function useHangarBuybacks<TData = Awaited<ReturnType<typeof hangarBuybacks>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarBuybacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarBuybacks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarBuybacksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Buy-back Insurance Terms
 */
export const hangarBuybackInsuranceTerms = (

 signal?: AbortSignal
) => {


      return axiosClient<BuybackInsuranceTerms>(
      {url: `/hangar/buybacks/insurance-terms`, method: 'GET', signal
    },
      );
    }




export const getHangarBuybackInsuranceTermsQueryKey = () => {
    return [
    'hangar','buybacks','insurance-terms'
    ] as const;
    }


export const getHangarBuybackInsuranceTermsQueryOptions = <TData = Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarBuybackInsuranceTermsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>> = ({ signal }) => hangarBuybackInsuranceTerms(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>, TError, TData>
}

export type HangarBuybackInsuranceTermsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>>
export type HangarBuybackInsuranceTermsQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Buy-back Insurance Terms
 */

export function useHangarBuybackInsuranceTerms<TData = Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarBuybackInsuranceTerms>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarBuybackInsuranceTermsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Remove a Hangar Buy-back Pledge
 */
export const destroyHangarBuyback = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/hangar/buybacks/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarBuybackMutationKey = () => ['destroyHangarBuyback'] as const;

export const getDestroyHangarBuybackMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarBuyback>>, TError,DestroyHangarBuybackMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarBuyback>>, TError,DestroyHangarBuybackMutationVariables, TContext> => {

const mutationKey = getDestroyHangarBuybackMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarBuyback>>, DestroyHangarBuybackMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyHangarBuyback(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarBuybackMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarBuyback>>>

    export type DestroyHangarBuybackMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarBuybackMutationVariables = {id: string}

    /**
 * @summary Remove a Hangar Buy-back Pledge
 */
export const useDestroyHangarBuyback = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarBuyback>>, TError,DestroyHangarBuybackMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarBuyback>>,
        TError,
        DestroyHangarBuybackMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarBuybackMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Equipment
 */
export const hangarEquipment = (
    params?: MaybeRefOrGetter<HangarEquipmentParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarPledgeItems>(
      {url: `/hangar/equipment`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarEquipmentQueryKey = (params?: MaybeRefOrGetter<HangarEquipmentParams>,) => {
    return [
    'hangar','equipment', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof hangarEquipment>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarEquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarEquipment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarEquipment>>> = ({ signal }) => hangarEquipment(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarEquipment>>, TError, TData>
}

export type HangarEquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof hangarEquipment>>>
export type HangarEquipmentQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Equipment
 */

export function useHangarEquipment<TData = Awaited<ReturnType<typeof hangarEquipment>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarEquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarEquipment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Export your personal Hangar
 */
export const hangarExport = (
    params?: MaybeRefOrGetter<HangarExportParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<VehicleExportsList>(
      {url: `/hangar/export`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarExportQueryKey = (params?: MaybeRefOrGetter<HangarExportParams>,) => {
    return [
    'hangar','export', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarExportQueryOptions = <TData = Awaited<ReturnType<typeof hangarExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarExport>>> = ({ signal }) => hangarExport(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarExport>>, TError, TData>
}

export type HangarExportQueryResult = NonNullable<Awaited<ReturnType<typeof hangarExport>>>
export type HangarExportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Export your personal Hangar
 */

export function useHangarExport<TData = Awaited<ReturnType<typeof hangarExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Export your personal Hangar for hangar.link
 */
export const hangarLinkExport = (
    params?: MaybeRefOrGetter<HangarLinkExportParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<VehicleExportsList>(
      {url: `/hangar/export/hangar-link`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarLinkExportQueryKey = (params?: MaybeRefOrGetter<HangarLinkExportParams>,) => {
    return [
    'hangar','export','hangar-link', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarLinkExportQueryOptions = <TData = Awaited<ReturnType<typeof hangarLinkExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarLinkExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarLinkExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarLinkExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarLinkExport>>> = ({ signal }) => hangarLinkExport(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarLinkExport>>, TError, TData>
}

export type HangarLinkExportQueryResult = NonNullable<Awaited<ReturnType<typeof hangarLinkExport>>>
export type HangarLinkExportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Export your personal Hangar for hangar.link
 */

export function useHangarLinkExport<TData = Awaited<ReturnType<typeof hangarLinkExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarLinkExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarLinkExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarLinkExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Flair
 */
export const hangarFlair = (
    params?: MaybeRefOrGetter<HangarFlairParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarPledgeItems>(
      {url: `/hangar/flair`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarFlairQueryKey = (params?: MaybeRefOrGetter<HangarFlairParams>,) => {
    return [
    'hangar','flair', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarFlairQueryOptions = <TData = Awaited<ReturnType<typeof hangarFlair>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarFlairParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarFlair>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarFlairQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarFlair>>> = ({ signal }) => hangarFlair(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarFlair>>, TError, TData>
}

export type HangarFlairQueryResult = NonNullable<Awaited<ReturnType<typeof hangarFlair>>>
export type HangarFlairQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Flair
 */

export function useHangarFlair<TData = Awaited<ReturnType<typeof hangarFlair>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarFlairParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarFlair>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarFlairQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Import to your personal Hangar
 */
export const hangarImport = (
    importInput: MaybeRefOrGetter<ImportInput>,
 signal?: AbortSignal
) => {
      importInput = toValue(importInput);

      return axiosClient<ImportSubmitResult>(
      {url: `/hangar/import`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: importInput, signal
    },
      );
    }




export const getHangarImportMutationKey = () => ['hangarImport'] as const;

export const getHangarImportMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarImport>>, TError,HangarImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hangarImport>>, TError,HangarImportMutationVariables, TContext> => {

const mutationKey = getHangarImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hangarImport>>, HangarImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hangarImport(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HangarImportMutationResult = NonNullable<Awaited<ReturnType<typeof hangarImport>>>
    export type HangarImportMutationBody = ImportInput
    export type HangarImportMutationError = ErrorType<ValidationError | StandardError>
    export type HangarImportMutationVariables = {data: ImportInput}

    /**
 * @summary Import to your personal Hangar
 */
export const useHangarImport = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarImport>>, TError,HangarImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof hangarImport>>,
        TError,
        HangarImportMutationVariables,
        TContext
      > => {
      return useMutation(getHangarImportMutationOptions(options), queryClient);
    }
    /**
 * @summary Your personal Hangar items
 */
export const hangarItems = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarItemsList>(
      {url: `/hangar/items`, method: 'GET', signal
    },
      );
    }




export const getHangarItemsQueryKey = () => {
    return [
    'hangar','items'
    ] as const;
    }


export const getHangarItemsQueryOptions = <TData = Awaited<ReturnType<typeof hangarItems>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarItems>>> = ({ signal }) => hangarItems(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarItems>>, TError, TData>
}

export type HangarItemsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarItems>>>
export type HangarItemsQueryError = ErrorType<StandardError>


/**
 * @summary Your personal Hangar items
 */

export function useHangarItems<TData = Awaited<ReturnType<typeof hangarItems>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Move all Ingame Ships from your Hangar to your Wishlist
 */
export const moveAllIngameToWishlist = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/hangar/move-all-ingame-to-wishlist`, method: 'PUT', signal
    },
      );
    }




export const getMoveAllIngameToWishlistMutationKey = () => ['moveAllIngameToWishlist'] as const;

export const getMoveAllIngameToWishlistMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, TError,void, TContext> => {

const mutationKey = getMoveAllIngameToWishlistMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, void> = () => {


          return  moveAllIngameToWishlist()
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveAllIngameToWishlistMutationResult = NonNullable<Awaited<ReturnType<typeof moveAllIngameToWishlist>>>

    export type MoveAllIngameToWishlistMutationError = ErrorType<StandardError>


    /**
 * @summary Move all Ingame Ships from your Hangar to your Wishlist
 */
export const useMoveAllIngameToWishlist = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveAllIngameToWishlist>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMoveAllIngameToWishlistMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Paints
 */
export const hangarPaints = (
    params?: MaybeRefOrGetter<HangarPaintsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarPledgeItems>(
      {url: `/hangar/paints`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarPaintsQueryKey = (params?: MaybeRefOrGetter<HangarPaintsParams>,) => {
    return [
    'hangar','paints', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarPaintsQueryOptions = <TData = Awaited<ReturnType<typeof hangarPaints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarPaintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPaints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarPaintsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarPaints>>> = ({ signal }) => hangarPaints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarPaints>>, TError, TData>
}

export type HangarPaintsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarPaints>>>
export type HangarPaintsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Paints
 */

export function useHangarPaints<TData = Awaited<ReturnType<typeof hangarPaints>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarPaintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarPaints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarPaintsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Report an RSI Page the Sync Does Not Recognise
 */
export const reportRsiPage = (
    rsiPageReportInput: MaybeRefOrGetter<RsiPageReportInput>,
 signal?: AbortSignal
) => {
      rsiPageReportInput = toValue(rsiPageReportInput);

      return axiosClient<void>(
      {url: `/hangar/rsi-page-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rsiPageReportInput, signal
    },
      );
    }




export const getReportRsiPageMutationKey = () => ['reportRsiPage'] as const;

export const getReportRsiPageMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRsiPage>>, TError,ReportRsiPageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reportRsiPage>>, TError,ReportRsiPageMutationVariables, TContext> => {

const mutationKey = getReportRsiPageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportRsiPage>>, ReportRsiPageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reportRsiPage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportRsiPageMutationResult = NonNullable<Awaited<ReturnType<typeof reportRsiPage>>>
    export type ReportRsiPageMutationBody = RsiPageReportInput
    export type ReportRsiPageMutationError = ErrorType<StandardError>
    export type ReportRsiPageMutationVariables = {data: RsiPageReportInput}

    /**
 * @summary Report an RSI Page the Sync Does Not Recognise
 */
export const useReportRsiPage = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRsiPage>>, TError,ReportRsiPageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reportRsiPage>>,
        TError,
        ReportRsiPageMutationVariables,
        TContext
      > => {
      return useMutation(getReportRsiPageMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Ship Components
 */
export const hangarShipComponents = (
    params?: MaybeRefOrGetter<HangarShipComponentsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarPledgeItems>(
      {url: `/hangar/ship-components`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarShipComponentsQueryKey = (params?: MaybeRefOrGetter<HangarShipComponentsParams>,) => {
    return [
    'hangar','ship-components', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarShipComponentsQueryOptions = <TData = Awaited<ReturnType<typeof hangarShipComponents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarShipComponentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarShipComponents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarShipComponentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarShipComponents>>> = ({ signal }) => hangarShipComponents(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarShipComponents>>, TError, TData>
}

export type HangarShipComponentsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarShipComponents>>>
export type HangarShipComponentsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Ship Components
 */

export function useHangarShipComponents<TData = Awaited<ReturnType<typeof hangarShipComponents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarShipComponentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarShipComponents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarShipComponentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Sync RSI Buy-back Pledge Details
 */
export const syncRsiBuybackDetails = (
    syncRsiBuybackDetailsInput: MaybeRefOrGetter<SyncRsiBuybackDetailsInput>,
 signal?: AbortSignal
) => {
      syncRsiBuybackDetailsInput = toValue(syncRsiBuybackDetailsInput);

      return axiosClient<BuybackDetailsSyncResult>(
      {url: `/hangar/sync-rsi-buyback-details`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: syncRsiBuybackDetailsInput, signal
    },
      );
    }




export const getSyncRsiBuybackDetailsMutationKey = () => ['syncRsiBuybackDetails'] as const;

export const getSyncRsiBuybackDetailsMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiBuybackDetails>>, TError,SyncRsiBuybackDetailsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncRsiBuybackDetails>>, TError,SyncRsiBuybackDetailsMutationVariables, TContext> => {

const mutationKey = getSyncRsiBuybackDetailsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncRsiBuybackDetails>>, SyncRsiBuybackDetailsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  syncRsiBuybackDetails(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncRsiBuybackDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof syncRsiBuybackDetails>>>
    export type SyncRsiBuybackDetailsMutationBody = SyncRsiBuybackDetailsInput
    export type SyncRsiBuybackDetailsMutationError = ErrorType<StandardError>
    export type SyncRsiBuybackDetailsMutationVariables = {data: SyncRsiBuybackDetailsInput}

    /**
 * @summary Sync RSI Buy-back Pledge Details
 */
export const useSyncRsiBuybackDetails = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiBuybackDetails>>, TError,SyncRsiBuybackDetailsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncRsiBuybackDetails>>,
        TError,
        SyncRsiBuybackDetailsMutationVariables,
        TContext
      > => {
      return useMutation(getSyncRsiBuybackDetailsMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync RSI Buy-back Pledges
 */
export const syncRsiBuybacks = (
    syncRsiBuybacksInput: MaybeRefOrGetter<SyncRsiBuybacksInput>,
 signal?: AbortSignal
) => {
      syncRsiBuybacksInput = toValue(syncRsiBuybacksInput);

      return axiosClient<BuybackSyncResult>(
      {url: `/hangar/sync-rsi-buybacks`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: syncRsiBuybacksInput, signal
    },
      );
    }




export const getSyncRsiBuybacksMutationKey = () => ['syncRsiBuybacks'] as const;

export const getSyncRsiBuybacksMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiBuybacks>>, TError,SyncRsiBuybacksMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncRsiBuybacks>>, TError,SyncRsiBuybacksMutationVariables, TContext> => {

const mutationKey = getSyncRsiBuybacksMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncRsiBuybacks>>, SyncRsiBuybacksMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  syncRsiBuybacks(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncRsiBuybacksMutationResult = NonNullable<Awaited<ReturnType<typeof syncRsiBuybacks>>>
    export type SyncRsiBuybacksMutationBody = SyncRsiBuybacksInput
    export type SyncRsiBuybacksMutationError = ErrorType<StandardError>
    export type SyncRsiBuybacksMutationVariables = {data: SyncRsiBuybacksInput}

    /**
 * @summary Sync RSI Buy-back Pledges
 */
export const useSyncRsiBuybacks = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiBuybacks>>, TError,SyncRsiBuybacksMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncRsiBuybacks>>,
        TError,
        SyncRsiBuybacksMutationVariables,
        TContext
      > => {
      return useMutation(getSyncRsiBuybacksMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync RSI Buy-back Pledges Last Read
 */
export const syncRsiBuybacksLastRead = (

 signal?: AbortSignal
) => {


      return axiosClient<BuybackSyncLastRead>(
      {url: `/hangar/sync-rsi-buybacks/last-read`, method: 'GET', signal
    },
      );
    }




export const getSyncRsiBuybacksLastReadQueryKey = () => {
    return [
    'hangar','sync-rsi-buybacks','last-read'
    ] as const;
    }


export const getSyncRsiBuybacksLastReadQueryOptions = <TData = Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSyncRsiBuybacksLastReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>> = ({ signal }) => syncRsiBuybacksLastRead(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>, TError, TData>
}

export type SyncRsiBuybacksLastReadQueryResult = NonNullable<Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>>
export type SyncRsiBuybacksLastReadQueryError = ErrorType<StandardError>


/**
 * @summary Sync RSI Buy-back Pledges Last Read
 */

export function useSyncRsiBuybacksLastRead<TData = Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiBuybacksLastRead>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSyncRsiBuybacksLastReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Sync RSI Hangar
 */
export const syncRsiHangar = (
    syncRsiHangarInput: MaybeRefOrGetter<SyncRsiHangarInput>,
 signal?: AbortSignal
) => {
      syncRsiHangarInput = toValue(syncRsiHangarInput);

      return axiosClient<HangarSyncSubmitResult>(
      {url: `/hangar/sync-rsi-hangar`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: syncRsiHangarInput, signal
    },
      );
    }




export const getSyncRsiHangarMutationKey = () => ['syncRsiHangar'] as const;

export const getSyncRsiHangarMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiHangar>>, TError,SyncRsiHangarMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncRsiHangar>>, TError,SyncRsiHangarMutationVariables, TContext> => {

const mutationKey = getSyncRsiHangarMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncRsiHangar>>, SyncRsiHangarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  syncRsiHangar(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncRsiHangarMutationResult = NonNullable<Awaited<ReturnType<typeof syncRsiHangar>>>
    export type SyncRsiHangarMutationBody = SyncRsiHangarInput
    export type SyncRsiHangarMutationError = ErrorType<StandardError>
    export type SyncRsiHangarMutationVariables = {data: SyncRsiHangarInput}

    /**
 * @summary Sync RSI Hangar
 */
export const useSyncRsiHangar = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiHangar>>, TError,SyncRsiHangarMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncRsiHangar>>,
        TError,
        SyncRsiHangarMutationVariables,
        TContext
      > => {
      return useMutation(getSyncRsiHangarMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync RSI Hangar Last Read
 */
export const syncRsiHangarLastRead = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarSyncLastRead>(
      {url: `/hangar/sync-rsi-hangar/last-read`, method: 'GET', signal
    },
      );
    }




export const getSyncRsiHangarLastReadQueryKey = () => {
    return [
    'hangar','sync-rsi-hangar','last-read'
    ] as const;
    }


export const getSyncRsiHangarLastReadQueryOptions = <TData = Awaited<ReturnType<typeof syncRsiHangarLastRead>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarLastRead>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSyncRsiHangarLastReadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof syncRsiHangarLastRead>>> = ({ signal }) => syncRsiHangarLastRead(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarLastRead>>, TError, TData>
}

export type SyncRsiHangarLastReadQueryResult = NonNullable<Awaited<ReturnType<typeof syncRsiHangarLastRead>>>
export type SyncRsiHangarLastReadQueryError = ErrorType<StandardError>


/**
 * @summary Sync RSI Hangar Last Read
 */

export function useSyncRsiHangarLastRead<TData = Awaited<ReturnType<typeof syncRsiHangarLastRead>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarLastRead>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSyncRsiHangarLastReadQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Sync RSI Hangar Status
 */
export const syncRsiHangarStatus = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarSyncStatus>(
      {url: `/hangar/sync-rsi-hangar/status`, method: 'GET', signal
    },
      );
    }




export const getSyncRsiHangarStatusQueryKey = () => {
    return [
    'hangar','sync-rsi-hangar','status'
    ] as const;
    }


export const getSyncRsiHangarStatusQueryOptions = <TData = Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSyncRsiHangarStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof syncRsiHangarStatus>>> = ({ signal }) => syncRsiHangarStatus(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError, TData>
}

export type SyncRsiHangarStatusQueryResult = NonNullable<Awaited<ReturnType<typeof syncRsiHangarStatus>>>
export type SyncRsiHangarStatusQueryError = ErrorType<StandardError>


/**
 * @summary Sync RSI Hangar Status
 */

export function useSyncRsiHangarStatus<TData = Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSyncRsiHangarStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Upgrades
 */
export const hangarUpgrades = (
    params?: MaybeRefOrGetter<HangarUpgradesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarPledgeItems>(
      {url: `/hangar/upgrades`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarUpgradesQueryKey = (params?: MaybeRefOrGetter<HangarUpgradesParams>,) => {
    return [
    'hangar','upgrades', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarUpgradesQueryOptions = <TData = Awaited<ReturnType<typeof hangarUpgrades>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarUpgradesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarUpgrades>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarUpgradesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarUpgrades>>> = ({ signal }) => hangarUpgrades(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarUpgrades>>, TError, TData>
}

export type HangarUpgradesQueryResult = NonNullable<Awaited<ReturnType<typeof hangarUpgrades>>>
export type HangarUpgradesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Upgrades
 */

export function useHangarUpgrades<TData = Awaited<ReturnType<typeof hangarUpgrades>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarUpgradesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarUpgrades>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarUpgradesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






